var _defs, _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVuejs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "0c14e6d7f7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 15.703125 L 374 15.703125 L 374 350 L 0 350 Z M 0 15.703125 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 16.105469 358.691406 L 16.09375 358.566406 L 16.078125 358.519531 Z M 16.105469 358.691406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#41b883",
    d: "M 10.976562 27.359375 L 186.722656 330.449219 L 362.46875 27.359375 L 292.164062 27.359375 L 186.722656 209.214844 L 80.394531 27.359375 Z M 10.976562 27.359375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#35495e",
    d: "M 80.394531 27.359375 L 186.722656 210.097656 L 292.179688 27.359375 L 227.144531 27.359375 L 186.722656 97.644531 L 145.414062 27.359375 Z M 80.394531 27.359375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0c14e6d7f7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 186.722656 349.878906 C 182.507812 349.878906 178.621094 347.609375 176.554688 343.941406 L 1.648438 33.15625 C -0.371094 29.550781 -0.339844 25.121094 1.742188 21.546875 C 3.839844 17.972656 7.664062 15.78125 11.816406 15.78125 L 78.171875 15.78125 C 78.589844 15.734375 79.042969 15.703125 79.492188 15.703125 L 145.429688 15.703125 C 149.613281 15.703125 153.453125 17.941406 155.535156 21.546875 L 186.722656 75.761719 L 217.957031 21.546875 C 220.039062 17.941406 223.894531 15.703125 228.0625 15.703125 L 294 15.703125 C 294.496094 15.703125 294.976562 15.734375 295.460938 15.796875 L 361.628906 15.796875 C 365.78125 15.796875 369.605469 18.003906 371.6875 21.5625 C 373.769531 25.136719 373.816406 29.566406 371.78125 33.171875 L 196.875 343.941406 C 194.824219 347.609375 190.9375 349.878906 186.722656 349.878906 Z M 31.761719 39.09375 L 186.722656 314.453125 L 341.683594 39.109375 L 293.953125 39.109375 C 293.453125 39.109375 292.972656 39.078125 292.492188 39.019531 L 234.808594 39.019531 L 196.828125 104.933594 C 194.746094 108.558594 190.890625 110.78125 186.722656 110.78125 C 182.539062 110.78125 178.699219 108.542969 176.617188 104.933594 L 138.683594 39.019531 L 80.816406 39.019531 C 80.394531 39.0625 79.945312 39.09375 79.492188 39.09375 Z M 31.761719 39.09375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuejs);
export default __webpack_public_path__ + "static/media/vuejs.55084649fd1144f9d7de299fb1e311c2.svg";
export { ForwardRef as ReactComponent };